export { DownloadAlt as default } from './DownloadAlt';
